import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { useOfferInlineEditStore } from './hooks/useOfferInlineEditStore';
import { getOfferInlineMetrics } from './offerInlineMetrics';
import type { IRowData } from './OfferTable';

interface OfferMarginCellProps {
  rowData: IRowData;
}

export const OfferMarginCell = ({ rowData }: OfferMarginCellProps) => {
  const localPrice = useOfferInlineEditStore(state => state.rows[rowData.product_uuid]?.localPrice ?? rowData.offer_final_price ?? null);
  const { margin } = getOfferInlineMetrics(rowData, localPrice);

  return (
    <div>
      <CurrencyFormat fixedDecimalScale decimalScale={1} value={margin} displayType="text" suffix="%" decimalSeparator="," thousandSeparator="." />
    </div>
  );
};
